export default "__VITE_PUBLIC_ASSET__55e884b0__"